import * as React from 'react';
import { NavLink, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { logout } from '../actions/auth';
import { toast } from 'react-toastify';
import * as Autocomplete from 'react-autocomplete';
import Axios, { AxiosResponse } from 'axios';
import config from '../config';

import i18n from "../config/i18next";
import { withTranslation } from 'react-i18next';

interface IState {
    query: string,
    searching: boolean,
    variants: string[]
}

const CancelToken = Axios.CancelToken;
let cancel: any;

class Navbar extends React.Component<any, IState>{
    public state: IState = {
        query: "",
        searching: false,
        variants: []
    };

    logoutHandler() {
        this.props.logout();
    }

    changeLanguage(lang: string) {
        i18n.changeLanguage(lang);
        localStorage.setItem('language', lang);
    }

    async onChangeHandler(value: string) {
        cancel && cancel();

        this.setState({
            query: value
        }, async () => {
            try {
                let response: AxiosResponse = await Axios.get(`${config.host}/stat/variants?query=${this.state.query}`, {
                    cancelToken: new CancelToken(function executor(c) {
                        cancel = c;
                    })
                });

                this.setState({
                    variants: response.data
                });
            } catch (err) {

            }
        });

    }

    search() {
        if (this.state.searching && this.state.query.length > 1) {
            this.setState({
                searching: false
            });

            return <Redirect to={"/search/" + this.state.query} />
        }
    }

    render() {

        const { t } = this.props;

        return (

            <section className="main-navbar">
                <div className="container">
                    <div className="flex">
                        <div className="left">
                            <ul className="nav-menu">
                                <li className="hover">
                                    <a> <i className="fa fa-bars"></i> </a>
                                    <div className="sub-menu">

                                        <div className="flex-menu">

                                            <ul className="r1">
                                                <li> <NavLink to="/films"> <i className="fa fa-film"></i> {t("Фильмы")} </NavLink> </li>
                                                <li> <NavLink to="/serials"> <i className="fa fa-play-circle"></i> {t("Сериалы")} </NavLink> </li>
                                                {/* <li> <NavLink to="/tv"> <i className="fa fa-tv"></i> {t("Онлайн ТВ")} </NavLink> </li> */}
                                                <li> <NavLink to="/trailers"> <i className="fa fa-video-camera"></i> {t("Трейлеры")} </NavLink> </li>
                                                <li> <NavLink to="/clips"> <i className="fa fa-play"></i> {t("Клипы")} </NavLink> </li>
                                                <li> <NavLink to="/music"> <i className="fa fa-music"></i> {t("Музыка")} </NavLink> </li>
                                                <li> <NavLink to="/albums"> <i className="fa fa-th-large"></i> {t("Альбомы")} </NavLink> </li>
                                                <li> <NavLink to="/singers"> <i className="fa fa-microphone"></i> {t("Испольнители")} </NavLink> </li>
                                            </ul>

                                            <ul className="r2">
                                                <li className="glav"> <NavLink to="/concerts"> <i className="fa fa-file-movie-o"></i> {t("Концерты")} </NavLink> </li>
                                                <li className="glav"> <NavLink to="/festivals"> <i className="fa fa-play-circle-o"></i> {t("Фестивали")} </NavLink> </li>
                                                <li className="glav"> <NavLink to="/show-business"> <i className="fa fa-star"></i> {t("Новости")} </NavLink> </li>
                                                <li className="glav"> <NavLink to="/wallpapers"> <i className="fa fa-picture-o"></i> {t("Обои")} </NavLink> </li>
                                                <li className="glav"> <NavLink to="/football"> <i className="fa fa-soccer-ball-o"></i> {t("Футбол")} </NavLink> </li>
                                                <li className="glav"> <a href="http://chat.okay.uz" target="_blink"> <i className="fa fa-commenting-o"></i> {t("Чат")} </a> </li>
                                            </ul>
                                        </div>
                                    </div>
                                </li>
                                <li className="logo">
                                    <NavLink to="/" className="menu_a ">
                                        <img src="/img/logo.png" />
                                    </NavLink>
                                    {/* <a href="/" className="menu_a ">
                                        <img src="/img/logo.png" />
                                    </a> */}
                                </li>
                                <li className="display"> <NavLink to="/films" className="menu_a "> {t("Фильмы")} </NavLink> </li>
                                <li className="display"> <NavLink to="/serials" className="menu_a "> {t("Сериалы")} </NavLink> </li>
                                <li className="display"> <NavLink to="/clips" className="menu_a "> {t("Клипы")} </NavLink> </li>
                                <li className="display"> <NavLink to="/music" className="menu_a "> {t("Музыка")} </NavLink> </li>
                                {/* <li className="display"> <NavLink to="/tv" className="menu_a "> {t("ТВ")} </NavLink> </li> */}
                            </ul>
                        </div>
                        <div className="dropdown language">
                            <button id="dLabel" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {i18n.language.toUpperCase()}
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="dLabel">
                                {i18n.language == "ru" && <li>
                                    <a onClick={() => {
                                        this.changeLanguage("uz");
                                    }}>
                                        <img src="/images/uz.jpg" /> O'zbekcha
                                    </a>
                                </li>}
                                {i18n.language == "uz" && <li>
                                    <a onClick={() => {
                                        this.changeLanguage("ru");
                                    }}>
                                        <img src="/images/ru.png" /> Русский
                                    </a>
                                </li>}
                            </ul>
                        </div>
                        <div className="form search-form">
                            <form id="search-form" onSubmit={(event: any) => {
                                event.preventDefault();

                                if (this.state.query.length > 1) {
                                    this.setState({
                                        searching: true
                                    });
                                } else {
                                    toast(t("Введите не менее 2 символов для поиска"));
                                }
                            }}>
                                <Autocomplete
                                    getItemValue={(item: any) => item.label}
                                    items={this.state.variants}
                                    renderItem={(item: any, isHighlighted: any) =>
                                        <div className="variant-item" style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                                            {item.label}
                                        </div>
                                    }
                                    menuStyle={{
                                        borderRadius: '3px',
                                        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
                                        background: 'rgba(255, 255, 255, 0.9)',
                                        padding: '0',
                                        fontSize: '90%',
                                        position: 'fixed',
                                        overflow: 'auto',
                                        maxHeight: '50%'
                                    }}
                                    inputProps={{ className: "w-100", placeholder: t("Фильмы, сериалы, актеры...") }}
                                    wrapperProps={{ className: "w-100" }}
                                    value={this.state.query}
                                    onChange={(e: any) => this.onChangeHandler(e.target.value)}
                                    onSelect={(val: any) => this.setState({
                                        query: val.trim()
                                    })}
                                />
                                {/* <input type="text" onChange={(event: any) => {
                                    this.setState({
                                        query: event.target.value
                                    });
                                }} placeholder="Фильмы, сериалы, актеры..." /> */}
                                <button type="submit" style={{ border: 0, background: "transparent" }}> <i className="fa fa-search"></i> </button>
                            </form>
                            {this.search()}
                        </div>
                        <div className="right">
                            <div className="vxod">
                                {this.props.auth.isAuthentificated ? (
                                    <div className="dropdown">
                                        <a onClick={(event: React.MouseEvent) => event.preventDefault()} type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <i className="fa fa-user"></i>
                                            <span>{this.props.auth.user.username}</span>
                                            <span className="caret"></span>

                                        </a>
                                        <ul className="dropdown-menu" aria-labelledby="dLabel">
                                            <li>
                                                <NavLink to="/profile">
                                                    <i className="fa fa-user"></i> {t("Мой профиль")}
                                                </NavLink>
                                            </li>
                                            <li>
                                                <a onClick={(event: React.MouseEvent) => {
                                                    event.preventDefault();

                                                    this.logoutHandler();
                                                }}>
                                                    <i className="fa fa-sign-out"></i> {t("Выйти")}
                                                </a>
                                            </li>
                                        </ul>
                                    </div>

                                ) : (
                                    <NavLink to="/login" className="">
                                        <i className="fa fa-sign-in"></i>
                                        <span>{t("Войти")}</span>
                                    </NavLink>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

function mapStateToProps(state: any) {
    return {
        auth: state.auth
    };
}

export default connect(mapStateToProps, { logout })(withTranslation()(Navbar));